import { Query, Store } from '@datorama/akita';
import { Observable } from 'rxjs';

export interface SimpleGenericStore<T> {
  entityState: T | null;
  loading: boolean;
  loaded: boolean;
}

export abstract class AbstractStateService<S> {
  protected constructor(readonly initialState: S, readonly storeName: string) {
    this.store = new Store(initialState, { name: storeName });
    this.query = new Query(this.store);
  }

  private readonly store: Store<S>;
  private readonly query: Query<S>;

  get state() {
    return this.store.getValue();
  }

  public select<K>(mapFn: (state: S) => K): Observable<K> {
    return this.query.select(mapFn);
  }

  public reset() {
    this.store.reset();
  }

  protected setState(newState: Partial<S>) {
    this.store.update(newState);
  }
}

export type getSimpleStateType<S> = S extends SimpleGenericStore<infer I> ? I : never;
